// @mui
import { styled } from '@mui/material/styles';
import { useState } from 'react';
// layouts
import Layout from '../../../layouts';
// components
import { useRouter } from 'next/router';
import licenseDetails from '../../../assets/licenseDetails.json';
import Page from '../../../components/Page';
import useLocales from '../../../hooks/useLocales';
import { removeFlags } from '../../../redux/slices/gplx.exam.slice';
import { setIndexLicenserReal } from '../../../redux/slices/gplx.quiz';
import { useDispatch } from '../../../redux/store';
// sections
import { Icon } from '@iconify/react';
import { Autocomplete, Box, Button, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import Image from '../../../components/Image';
import useSettings from '../../../hooks/useSettings';
import { findExamsAPI } from "../../../service/gplx.exam.service";
const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));
const gplx = [
  { label: 'A1', index: 0 },
  { label: 'A2', index: 1 },
  { label: 'A3', index: 2 },
  { label: 'A4', index: 3 },
  { label: 'B1', index: 4 },
  { label: 'B2', index: 5 },
  { label: 'C', index: 6 },
  { label: 'D', index: 7 },
  { label: 'E', index: 8 },
  { label: 'F', index: 9 },
];
Start.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function Start({ exams }) {
  const { themeStretch } = useSettings();
  const { translate } = useLocales();
  const router = useRouter();
  const dispatch = useDispatch();
  const [value, setValue] = useState(gplx[0]);
  const [totalExams, setTotalExams] = useState(licenseDetails[0].totalExams);

  const handleChange = (value) => {
    setValue(value);
    if (value === "") {
      setTotalExams(licenseDetails[value.index].totalExams);
    }
  };

  const handleReady = () => {
    const examIndex = getRandomInt(1, totalExams);
    dispatch(
      setIndexLicenserReal({
        index: value.index,
        examIndex,
        time: licenseDetails[value.index].time,
        require: { correctAnswer: licenseDetails[value.index].correctAnswer, name: licenseDetails[value.index].name },
      })
    );
    router.push(`/thi-gplx/thi-that/${examIndex}`);
  };

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const handleReadySituation = () => {
    const idx = getRandomInt(0, exams.length - 1);
    const slug = exams[idx].slug;
    dispatch(removeFlags());
    router.push(`/thi-tinh-huong/thi-that/${slug}`);
  };

  return (
    <Page title={translate('realHome.title')} description={translate('realHome.description')}>
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <Box border={'2px solid #05163b'}>
            <Image src="/illustrations/banner-exam.jpg" height={50} />
            <Grid container>
              <Grid item sm={6} xs={12} border={'2px solid #05163b'} p={1}>
                <Typography my={2} variant="h3" textAlign={"center"}>
                  THI LÝ THUYẾT
                </Typography>
                <Stack direction={'row'} spacing={1} alignItems={"center"} >
                  <Typography variant="subtitle1">
                    Hạng GPLX:
                  </Typography>
                  <Autocomplete
                    value={value}
                    onChange={(_, newValue) => handleChange(newValue)}
                    id="gplx"
                    options={gplx}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params} label="Chọn hạng bằng" />}
                  />
                  <TextField label="Điền số báo danh của bạn" />
                </Stack>
                <Button sx={{ ml: 12, my: 3 }} variant="contained" onClick={handleReady} startIcon={<Icon icon="simple-line-icons:login" />}>
                  Bắt đầu
                </Button>
              </Grid>
              <Grid item sm={6} xs={12} border={'2px solid #05163b'} p={1} >
                <Typography my={2} variant="h3" textAlign={"center"}>
                  THI MÔ PHỎNG
                </Typography>
                <Stack direction={'row'} spacing={1} alignItems={"center"}>
                  <Typography variant="subtitle1">
                    Số báo danh:
                  </Typography>
                  <TextField label="Điền số báo danh của bạn" />
                </Stack>
                <Button sx={{ ml: 12, my: 3 }} variant="contained" onClick={handleReadySituation} startIcon={<Icon icon="simple-line-icons:login" />}>
                  Bắt đầu
                </Button>
              </Grid>
            </Grid>
          </Box>
        </RootStyle>
      </Container>
    </Page >
  );
}
export async function getStaticProps() {
  // Fetch necessary data for the blog post using params.id
  const search = { page: 0, size: 50, value: '%%', orders: [{ order: 'asc', property: 'orderNo' }] };

  const { code, data: exams } = await findExamsAPI(search);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      exams
    },
  };
}